import React from "react";
import MembershipReservationPopupContainer from "../../organisms/common/membershipReservationPopupContainer";
import { HeaderContainer } from "../../organisms/common/headerContainer";
import SubHeader3 from '../../../resources/image/subHeader3_3.png';
import { SubHeader } from '../../molecules/subHeader';
import EstheticReserveCompleteContainer from "../../organisms/esthetic/estheticReserveCompleteContainer";
import MembershipCancelPopup from "../../organisms/common/membershipCancelPopup";

class EstheticReserveCompleteTemplate extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer
          Label categoryLabel1={"予約完了"}
          categoryLabel2={"COMPLETE"}
          bookedConfirmLabel={this.props.state.loginFlg ? "予約確認" : ""}
          importedFlg={true}
          onClickOpenReservationPopupWindow={this.props.state.loginFlg ? this.props.onClickOpenReservationPopupWindow : ""}
        />
        <SubHeader SubImage={SubHeader3} />
        <MembershipReservationPopupContainer
          state={this.props.state}
          onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
        />
        <MembershipCancelPopup
          state={this.props.state}
          onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
        />
        <EstheticReserveCompleteContainer
          state={this.props.state}
        />
      </div>
    );
  }
}

export default EstheticReserveCompleteTemplate;